import React, { useEffect } from "react";
import { OrderStatus } from "@repo/database";

import { useOrder } from "~/hooks/use-order";
import { useOrderStore } from "~/stores/use-order-store";
import OnlineOrderDialog from "./online-order-dialog";

export default function OnlineOrderManager() {
  const { onlineOrders } = useOrder();
  const currentOnlineOrderQueue = useOrderStore(
    (state) => state.currentOnlineOrderQueue,
  );

  const removeFromCurrentOnlineOrderQueue = useOrderStore(
    (state) => state.removeFromCurrentOnlineOrderQueue,
  );

  const currentOnlineOrder = useOrderStore((state) => state.currentOnlineOrder);

  const setCurrentOnlineOrder = useOrderStore(
    (state) => state.setCurrentOnlineOrder,
  );
  useEffect(() => {
    if (currentOnlineOrder) return;
    if (currentOnlineOrderQueue.length > 0) {
      setCurrentOnlineOrder(currentOnlineOrderQueue[0]);
    } else {
      setCurrentOnlineOrder(undefined);
    }
  }, [currentOnlineOrderQueue, currentOnlineOrder, setCurrentOnlineOrder]);

  useEffect(() => {
    for (const orderInQueue of currentOnlineOrderQueue) {
      if (
        onlineOrders.find(
          (order) =>
            order.id === orderInQueue.id &&
            order.orderStatus !== OrderStatus.new,
        )
      ) {
        removeFromCurrentOnlineOrderQueue(orderInQueue);
      }
    }
  }, [
    onlineOrders,
    currentOnlineOrderQueue,
    removeFromCurrentOnlineOrderQueue,
  ]);

  return (
    <>
      <OnlineOrderDialog />
    </>
  );
}
